import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LeaveRequestsList = ({ requests, onCancel, loading }) => {
  const statusConfig = {
    pending: {
      label: 'Pending',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      icon: 'Clock'
    },
    approved: {
      label: 'Approved',
      color: 'text-success',
      bgColor: 'bg-success/10',
      icon: 'CheckCircle'
    },
    rejected: {
      label: 'Rejected',
      color: 'text-error',
      bgColor: 'bg-error/10',
      icon: 'XCircle'
    },
    cancelled: {
      label: 'Cancelled',
      color: 'text-muted-foreground',
      bgColor: 'bg-muted',
      icon: 'Ban'
    }
  };

  const leaveTypeLabels = {
    annual: 'Annual Leave',
    sick: 'Sick Leave',
    maternity: 'Maternity Leave',
    long_service: 'Long Service Leave'
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Icon name="Loader2" className="animate-spin h-8 w-8 text-primary" />
      </div>
    );
  }

  if (!requests || requests?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="Calendar" size={48} className="mx-auto mb-4 text-muted-foreground" />
        <p className="text-muted-foreground">No leave requests found</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {requests?.map((request) => {
        const status = statusConfig?.[request?.leaveStatus] || statusConfig?.pending;
        
        return (
          <div key={request?.id} className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-smooth">
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <h4 className="font-semibold text-foreground">
                    {leaveTypeLabels?.[request?.leaveType] || request?.leaveType}
                  </h4>
                  <span className={`px-2 py-1 rounded text-xs font-medium ${status?.bgColor} ${status?.color}`}>
                    <Icon name={status?.icon} size={12} className="inline mr-1" />
                    {status?.label}
                  </span>
                </div>
                <div className="flex items-center gap-4 text-sm text-muted-foreground">
                  <span>
                    <Icon name="Calendar" size={14} className="inline mr-1" />
                    {new Date(request?.startDate)?.toLocaleDateString()} - {new Date(request?.endDate)?.toLocaleDateString()}
                  </span>
                  <span>
                    <Icon name="Clock" size={14} className="inline mr-1" />
                    {request?.daysRequested} days
                  </span>
                </div>
              </div>
              {request?.leaveStatus === 'pending' && (
                <Button
                  variant="ghost"
                  size="sm"
                  iconName="X"
                  onClick={() => onCancel?.(request?.id)}
                  className="text-error hover:bg-error/10"
                >
                  Cancel
                </Button>
              )}
            </div>

            {request?.reason && (
              <div className="bg-muted/30 rounded-lg p-3 mb-3">
                <p className="text-xs text-muted-foreground mb-1">Reason</p>
                <p className="text-sm text-foreground">{request?.reason}</p>
              </div>
            )}

            {request?.approvedBy && (
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Icon name="User" size={12} />
                <span>
                  {request?.leaveStatus === 'approved' ? 'Approved' : 'Processed'} by {request?.approvedBy} on {new Date(request?.approvedAt)?.toLocaleDateString()}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default LeaveRequestsList;
